import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CarServices from '../../services/CarServices';
import CategoryServices from '../../services/CategoryServices';
import ReactQuill from 'react-quill';

function AddService() {
    const navigate = useNavigate();


    const [formValues, setFormValues] = useState({
        terms: '',
        category: '',
        subCategory: '',
        title: '',
        description: '',
        included: [''],
        // minutes: '',
        tax: '',
        serviceLabelLeft: '',
        serviceLabelRight: '',
        images: [],
    });

    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [previewImages, setPreviewImages] = useState([]);
    const [uploading, setUploading] = useState(false);

    // const [price, setPrice] = useState('');
    // const [offerPrice, setOfferPrice] = useState('');
    const [discountPercentage, setDiscountPercentage] = useState('');

    /* ================= DISCOUNT ================= */
    // useEffect(() => {
    //     if (price && offerPrice) {
    //         const discount = Math.round((1 - offerPrice / price) * 100);
    //         setDiscountPercentage(discount);
    //     } else {
    //         setDiscountPercentage('');
    //     }
    // }, [price, offerPrice]);

    /* ================= CATEGORY ================= */
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await CategoryServices.getCategoryActive();
                if (res.status) setCategories(res.data);
            } catch (err) {
                console.error(err);
            }
        };
        fetchCategories();
    }, []);

    /* ================= INPUT ================= */
    const handleInputChange = async (event) => {
        const { name, value } = event.target;

        if (name === 'category') {
            setFormValues(prev => ({
                ...prev,
                category: value,
                subCategory: '',
            }));

            if (value) {
                try {
                    const res = await CategoryServices.getSubCategoryByCategory(value);
                    if (res.status && Array.isArray(res.data)) {
                        setSubCategories(res.data);
                    } else {
                        setSubCategories([]);
                    }
                } catch {
                    setSubCategories([]);
                }
            } else {
                setSubCategories([]);
            }
            return;
        }

        // if (name === 'price') {
        //     setPrice(value);
        //     return;
        // }

        // if (name === 'offerPrice') {
        //     setOfferPrice(value);
        //     return;
        // }

        setFormValues(prev => ({ ...prev, [name]: value }));
    };

    /* ================= INCLUDED ================= */
    // const handleIncludedChange = (index, e) => {
    //     const arr = [...formValues.included];
    //     arr[index] = e.target.value;
    //     setFormValues(prev => ({ ...prev, included: arr }));
    // };

    const addIncluded = () =>
        setFormValues(prev => ({ ...prev, included: [...prev.included, ''] }));

    const removeIncluded = (index) =>
        setFormValues(prev => ({
            ...prev,
            included: prev.included.filter((_, i) => i !== index)
        }));

    /* ================= IMAGE ================= */
    const handleFileChange = async (event) => {
        const files = Array.from(event.target.files);
        if (!files.length) return;

        setUploading(true);
        try {
            const formData = new FormData();
            files.forEach(file => formData.append('images', file));

            const res = await CarServices.uploadImage(formData);
            if (Array.isArray(res.images)) {
                setFormValues(prev => ({
                    ...prev,
                    images: [...prev.images, ...res.images],
                }));
                setPreviewImages(prev => [...prev, ...res.images]);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setUploading(false);
            event.target.value = null;
        }
    };

    const handleRemoveImage = async (img) => {
        try {
            const res = await CarServices.removeImage({ url: img });
            if (res.status) {
                setFormValues(prev => ({
                    ...prev,
                    images: prev.images.filter(i => i !== img),
                }));
                setPreviewImages(prev => prev.filter(i => i !== img));
            }
        } catch (err) {
            console.error(err);
        }
    };

    /* ================= SUBMIT ================= */
    const handleSubmit = async (event) => {
        event.preventDefault();

            console.log('sasa', formValues);
            
        const payload = {
            ...formValues,
            // price,
            // offerPrice,
            // discountPercentage,
        };

        try {
            const res = await CarServices.createService(payload);
            if (res.status) {
                alert('Service created successfully');
                navigate('/service');
            }
        } catch (err) {
            console.error(err);
            alert('Submit failed');
        }
    };

    return (
        <div className="right_col">
            <div className="title-box">
                <h2>Service Add</h2>
                <Link className="list-banner-btn" to="/service">Service List</Link>
            </div>

            <div className="container-box px-5">
                <form onSubmit={handleSubmit}>
                    <div className="row">

                        <div className="col-lg-6">
                            <label>Category*</label>
                            <select
                                name="category"
                                className="form-control"
                                value={formValues.category}
                                onChange={handleInputChange}
                                required
                            >
                                <option value="">Select Category</option>
                                {categories.map(cat => (
                                    <option key={cat._id} value={cat._id}>{cat.title}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-lg-6">
                            <label>Sub Category*</label>
                            <select
                                name="subCategory"
                                className="form-control"
                                value={formValues.subCategory}
                                onChange={handleInputChange}
                                disabled={!formValues.category}
                                required
                            >
                                <option value="">Select Sub Category</option>
                                {subCategories.map(sub => (
                                    <option key={sub._id} value={sub._id}>{sub.title}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-lg-6 mt-3">
                            <label>Title*</label>
                            <input className="form-control"
                                name="title"
                                value={formValues.title}
                                onChange={handleInputChange}
                                required />
                        </div>

                        <div className="col-lg-6 mt-3">
                            <label>Description*</label>
                            <input className="form-control"
                                name="description"
                                value={formValues.description}
                                onChange={handleInputChange}
                                required />
                        </div>

                        {/* <div className="col-lg-3 mt-3">
                            <label>Main Price*</label>
                            <input type="number" className="form-control"
                                name="price" value={price}
                                onChange={handleInputChange} required />
                        </div> */}

                        {/* <div className="col-lg-3 mt-3">
                            <label>Offer Price*</label>
                            <input type="number" className="form-control"
                                name="offerPrice" value={offerPrice}
                                onChange={handleInputChange} required />
                        </div> */}

                        {/* <div className="col-lg-3 mt-3">
                            <label>Discount %</label>
                            <input className="form-control"
                                value={discountPercentage} readOnly />
                        </div> */}

                        {/* <div className="col-lg-3 mt-3">
                            <label>Minutes*</label>
                            <input type="number" className="form-control"
                                name="minutes"
                                value={formValues.minutes}
                                onChange={handleInputChange} required />
                        </div> */}

                        {/* <div className="col-lg-12 mt-3">
                            <label>What's Included*</label>
                            {formValues.included.map((v, i) => (
                                <div key={i} className="input-group mb-2">
                                    <input className="form-control"
                                        value={v}
                                        onChange={(e) => handleIncludedChange(i, e)}
                                        required />
                                    <button type="button" className="btn btn-danger"
                                        onClick={() => removeIncluded(i)}>×</button>
                                </div>
                            ))}
                            <button type="button" className="btn btn-secondary"
                                onClick={addIncluded}>+ Add</button>
                        </div> */}

                        <div className="col-lg-12 mt-3">
                            <label>Upload Images</label>
                            <input type="file" multiple
                                className="form-control"
                                onChange={handleFileChange} />
                            <div className="image-preview-container-service">
                                {previewImages.map((img, i) => (
                                    <div key={i}>
                                        <img src={`${process.env.REACT_APP_URL}${img}`} width="100" />
                                        <button type="button"
                                            onClick={() => handleRemoveImage(img)}>X</button>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="col-lg-12 mt-3">
                            <label>Terms & Conditions</label>
                            <ReactQuill
                                value={formValues.terms}
                                onChange={(v) =>
                                    setFormValues(p => ({ ...p, terms: v }))
                                }
                            />
                        </div>
                    </div>

                    <button className="submit-green-btn mt-4">SUBMIT</button>
                </form>
            </div>
        </div>
    );
}

export default AddService;
